import { Double } from "./double";

export default Double;